import { FC, MouseEvent } from 'react';
// Icons
import { FaTimes } from 'react-icons/fa';
// Components
import { IconButton } from 'components/Buttons';

type Props = {
  title: string;
  onClose?: () => void;
  children?: React.ReactNode;
  additionalButton?: React.ReactNode;
}

const DialogTitle:FC<Props> = ({
  title, onClose, children, additionalButton
}) => {

  const handleOnClose = (event:MouseEvent<HTMLButtonElement> | undefined) => {
    event?.stopPropagation();
    if (onClose) onClose();
  }

  return (
    <div className="p-4 border-b border-gray-500">
      <div className="flex items-center gap-4">
        <h3 className="text-2xl text-white font-semibold pr-4 flex-grow">
          {title}
        </h3>
        {additionalButton}
        {onClose ? (
          <IconButton
            onClick={handleOnClose}
          ><FaTimes /></IconButton>
        ) : null}
      </div>
      {children}
    </div>
  )
}

export default DialogTitle;
